import { createStore, createEvent } from "effector"
import { IGlobalAssetOverviewAssetSidebarProps } from "components/GlobalAssetOverviewAssetSidebar/GlobalAssetOverviewAssetSidebar"

const show = createEvent<IGlobalAssetOverviewAssetSidebarProps>()
const hide = createEvent<IGlobalAssetOverviewAssetSidebarProps>()
const clear = createEvent()

const list = createStore<IGlobalAssetOverviewAssetSidebarProps[]>([])

list.on(show,
    (state: IGlobalAssetOverviewAssetSidebarProps[], props: IGlobalAssetOverviewAssetSidebarProps) => {
        return [...state, props]
    }
)

list.on(hide,
    (state: IGlobalAssetOverviewAssetSidebarProps[], props: IGlobalAssetOverviewAssetSidebarProps) => {
        return state.filter(p => p !== props)
    }
)

list.on(clear,
    () => []
)

export default {
    show,
    hide,
    clear,
    list,
}
